import { createContext } from 'react';

export default createContext({
  saveAsOption: false,
  options: undefined,
  setOptions: undefined,
  toggleOption: undefined,
  filter: undefined,
  setFilter: undefined,
  visibilityPredicate: undefined,
});
